import { Col, Container, Row } from "reactstrap";
import { convertCurrency } from "../../../../utility/Utils";
import styles from "./PurchaseHistory.module.scss";
import FilterInTable from "../../../Manage/FilterInTable";
import CustomDropdown from "../../../../components/common/Dropdown/CustomDropDown";
import DatatableComponent from "../../../../components/common/DatatableComponent/DatatableComponent";

const PurchaseHistory = () => {
  const metricesCol1Data = [
    { label: "Total Number of Customers:", value: convertCurrency(1500) },
    { label: "Average Purchase Frequency:", value: "4 purchases per month" },
    { label: "Average Order Value (AOV):", value: 75 },
    { label: "Customer Retention Rate:", value: "60%" },
    { label: "Repeat Customer Rate:", value: 3 },
  ];

  const metricesCol2Data = [
    { label: "Customer Lifetime Value (CLV):", value: 450 },
    { label: "Churn Rate:", value: 15 },
    { label: "Most Popular Product:", value: "Eco Travel Mug" },
    { label: "Seasonal Purchase Peak:", value: "November / December" },
    {
      label: "New vs. Returning Customer Sales:",
      value: "40% New / 60% Returning",
    },
  ];

  const tableData = [
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
  ];

  const columns = [
    {
      name: "Customer ID",
      selector: (row) => row.customerId,
      minWidth: "140px",
    },
    {
      name: "Customer name",
      selector: (row) => row.customerName,
      minWidth: "160px",
    },
    {
      name: "Total Purchases",
      selector: (row) => row.totalPurchases,
      minWidth: "160px",
    },
    {
      name: "Last Purchase Date",
      selector: (row) => row.lastPurchaseDate,
      minWidth: "180px",
    },
    {
      name: "Total Spent",
      selector: (row) => row.totalSpent,
      minWidth: "140px",
    },
    {
      name: "Most Purchased Product",
      selector: (row) => row.mostPurchasedProduct,
      minWidth: "220px",
    },
    {
      name: "Action",
      cell: () => (
        <CustomDropdown
          title="Action"
          options={["View details", "Print", "Contact"]}
        />
      ),
    },
  ];

  return (
    <div className={styles["wrapper"]}>
      <div className="fw-semibold fs-4 mb-3">Purchase History</div>

      <div class="fw-semibold fs-5 mt-3 mb-2">Metrices</div>

      <Container fluid className="p-0 px-lg-3 mb-2">
        <Row className="g-0 row-gap-3">
          <Col xl={6} className="pe-xl-3">
            <div className={styles["stats"]}>
              {metricesCol1Data.map((item, index) => (
                <Row className="g-0" key={index}>
                  <Col>{item.label}</Col>
                  <Col xs="4" className={styles["text-yellow"]}>
                    {item.value}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
          <Col xl={6} className="ps-xl-3">
            <div className={styles["stats"]}>
              {metricesCol2Data.map((item, index) => (
                <Row className="g-0" key={index}>
                  <Col>{item.label}</Col>
                  <Col xs="4" className={styles["text-yellow"]}>
                    {item.value}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
        </Row>
      </Container>

      <h5 className="fw-semibold my-3">Customer Purchase History</h5>

      <div className={styles["outer-wrapper"]}>
        <FilterInTable componentName="Purchase History" />
        <div className="mt-3">
          <DatatableComponent
            data={tableData}
            columns={columns}
            type={"yellow-bordered"}
            responsive
            pagination
          />
        </div>
      </div>

    </div>
  );
};

export default PurchaseHistory;